import React, { useEffect, useState } from 'react';
import PracticeServiceTypeService from '../../../../../services/api/practice-service-type.service'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
const AddPracticeServiceTypeImage = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const [imagePath, setImagePath] = useState()
    const [selectedFile, setSelectedFile] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const getImageUrl = () => {
        let imagePath = props.practiceServiceType.imagePath;
        if (imagePath) {
            setImagePath(imagePath)
        }
    }

    const uploadPracticeServiceTypeImage = (e) => {
        setIsLoader(true)
        PracticeServiceTypeService.uploadPracticeServiceTypeImage(selectedFile,props.practiceServiceType.practiceServiceTypeId)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    useEffect(() => {
        getImageUrl()
    }, [])
    return (
        <div>
            {isLoader && <DimLoader />}
            <div className='row d-flex justify-content-around'>
                <div className='col-12'>
                    <div className='card m-3'>
                        <div className='bg-primary d-flex justify-content-center'>
                            <div style={{ backgroundImage: `url(${imagePath})` }} className="logo-upload" />
                        </div>
                        <hr className='p-0 m-0' />
                        <div className="card-body">
                            <input className="" type="file" id="formFile" 
                            onChange={e => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                if (file) {
                                    setSelectedFile(file)
                                    const newImageUrl = URL.createObjectURL(file);
                                    setImagePath(newImageUrl);
                                }
                            }}
                            />
                        </div>
                        <div>
                            <span className="text-danger small lh-sm">
                                <div>Please upload an image in PNG, JPEG, GIF, BMP, or TIFF format</div>
                                <div>Maximum Image size allowed is 1 MB</div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-3 d-flex justify-content-between modal-button-bar'>
                <div className='col-auto'>
                    <button className="btn btn-primary" onClick={(e) => {
                        e.preventDefault();
                        uploadPracticeServiceTypeImage()
                    }}>Update</button>
                </div>
                <div className='col-auto'>
                    <button className="btn btn-secondary" onClick={(e) => { e.preventDefault(); if (props.onClose()) { props.onClose() } }}> Cancel </button>
                </div>
            </div>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </div>
    )
}

export default AddPracticeServiceTypeImage;